<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Asignaciones Pendientes"
          :icon="'grid'"
        />
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiURL";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      tableId: "pending-assignments-table",
      rowData: {},
      options: {
        name: "pending-assignments-table",
        url: `${actions.PENDING_ASSIGNMENTS}`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      window.location = `${actions.PENDING_ASSIGNMENTS}/edit/${this.rowData.id}`;
    },

    data() {},
  },
};
</script>
